import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  assignTransactionResult,
  customerTransactionData,
  depositsSummaryData,
  generateSucceededDetailsData,
} from './fixtures/transactions.fixture';

export const listCustomerTransactionsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-transactions/clients/:clientId/transactions`,
    fn,
  );

export const listDepositsSummaryMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-payments/payouts`,
    fn,
  );

export const generateDetailsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/payouts/payout-summary/:payoutId`,
    fn,
  );

export const assignTransactionMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-transactions/assigntransaction`,
    fn,
  );

export const handlers = () => [
  listCustomerTransactionsMock((req, res, ctx) => {
    return res(ctx.json(customerTransactionData));
  }),

  listDepositsSummaryMock((_req, res, ctx) => {
    return res(ctx.json(depositsSummaryData));
  }),

  generateDetailsMock((_req, res, ctx) => {
    return res(ctx.json(generateSucceededDetailsData));
  }),

  assignTransactionMock((_req, res, ctx) => {
    return res(ctx.json(assignTransactionResult));
  }),
];
